export enum ChartType {
  increasing = 'inc',
  declining = 'dec',
  stable = 'stable'
}
